import React, { useState } from "react"
import ChevronIcon from "../icons/chevron"
import classNames from "../utils/classnames"

interface IFlexTableProps {
  mobileColumnLabels?: boolean
  headings: Array<{
    label: string
    width:
    | "auto"
    | "w-1/12"
    | "w-2/12"
    | "w-3/12"
    | "w-4/12"
    | "w-5/12"
    | "w-6/12"
    | "w-7/12"
    | "w-8/12"
    | "w-9/12"
    | "w-10/12"
    | "w-11/12"
  }>
  rows: Array<Array<JSX.Element>>
  className?: string
  maxHeight?: number
  footer?: JSX.Element
  initialSortColumn?: number
  initialSortReverse?: boolean
}

// generated classes for tailwind (do not delete): lg:w-1/12 lg:w-2/12 lg:w-3/12 lg:w-4/12 lg:w-5/12 lg:w-6/12 lg:w-7/12 lg:w-8/12 lg:w-9/12 lg:w-10/12 lg:w-11/12

interface IFlexTableCellProps {
  children: JSX.Element | string
  sortValue?: string
}
export function FlexTableCell(props: IFlexTableCellProps): JSX.Element {
  return <>{props.children}</>
}

export function FlexTableRowMore(props: {
  children: JSX.Element
}): JSX.Element {
  return <>{props.children}</>
}

const getFavorite = (
  id: string
): boolean => // true
  typeof window !== `undefined`
    ? localStorage.getItem(`favoriteGeorgianProgram_${id}`) === `true`
    : false

const FlexTable = (props: IFlexTableProps): JSX.Element => {
  // console.log(`flex-table view`)
  const {
    headings,
    rows,
    className,
    maxHeight,
    footer,
    mobileColumnLabels = true,
    initialSortColumn = 0,
    initialSortReverse = false,
  } = props
  const [sort, setSort] = useState(initialSortColumn)
  const [sortReverse, setSortReverse] = useState(initialSortReverse)
  const [expanded, setExpanded] = useState<Array<number>>([])
  return (
    <div className={classNames(className || ``)}>
      <div className={classNames(`text-left border border-lightgray grow-0`)}>
        <div
          className={classNames(
            // maxHeight ? `overflow-y-scroll` : ``,
            `bg-white border-b border-b-gray-200 lg:flex`,
            !mobileColumnLabels ? `hidden` : ``
          )}
        >
          {headings.map((heading, index) => (
            <div
              onClick={() => {
                if (sort === index) {
                  setSortReverse(!sortReverse)
                } else {
                  setSort(index)
                  setSortReverse(false)
                }
              }}
              key={index}
              className={classNames(
                `flex gap-2 cursor-pointer items-center px-4 py-2 lg:${heading.width}`
              )}
            >
              {sort === index && (
                <ChevronIcon
                  className={classNames(
                    `h-3 w-3`,
                    sortReverse ? `rotate-90` : `-rotate-90`
                  )}
                />
              )}
              <span>{heading.label}</span>
            </div>
          ))}
        </div>
        <div
          className={classNames(maxHeight ? `overflow-y-scroll` : ``)}
          style={{ maxHeight: maxHeight ? maxHeight : undefined }}
        >
          {rows
            .sort((a, b) => {
              // console.log(`sort`, sort, a[sort], b[sort])
              let aVal = a[sort]?.props.sortValue ?? a[sort]?.props.children
              let bVal = b[sort]?.props.sortValue ?? b[sort]?.props.children

              // for only StarIconComponent which uses localStorage
              if (sort == 0 && a[sort]?.key?.endsWith(`-star`)) {
                aVal = !getFavorite(a[sort].props.id)
                bVal = !getFavorite(b[sort].props.id)
              }

              if (aVal < bVal) {
                return sortReverse ? 1 : -1
              }
              if (aVal > bVal) {
                return sortReverse ? -1 : 1
              }
              return 0
            })
            .map((row, rowIndex) => {
              const more = row?.find((_, i) => i > headings.length - 1)
              return (
                <>
                  <div
                    onClick={
                      more
                        ? () => {
                          if (expanded.includes(rowIndex)) {
                            setExpanded(expanded.filter(i => i !== rowIndex))
                          } else {
                            setExpanded([...expanded, rowIndex])
                          }
                        }
                        : undefined
                    }
                    key={rowIndex}
                    className={classNames(
                      rowIndex % 2 === 0 ? `bg-lightblue` : `bg-white`,
                      `hover:bg-lightgray flex flex-col lg:flex-row`,
                      more ? `cursor-pointer` : ``,
                      expanded.includes(rowIndex)
                        ? `border border-gray-100 border-b-0`
                        : ``
                    )}
                  >
                    {row
                      ?.filter((_, i) => i < headings.length)
                      .map((cell, cellIndex) => (
                        <div
                          key={`${rowIndex} ${cellIndex}`}
                          className={classNames(
                            `px-4 py-4 lg:py-2 align-text-top lg:${headings[cellIndex]?.width ?? `w-auto`
                            }`,
                            more ? `flex gap-2` : ``
                          )}
                        >
                          {more && cellIndex === 0 && (
                            <ChevronIcon
                              className={classNames(
                                `w-4 h-4 mt-1 -ml-1 transition-transform`,
                                expanded.includes(rowIndex) ? `rotate-90` : ``
                              )}
                            />
                          )}
                          {cell}
                        </div>
                      ))}
                  </div>
                  {more && expanded.includes(rowIndex) && (
                    <div
                      className={classNames(
                        `w-full p-4 pl-8 bg-lightgray-100`,
                        expanded.includes(rowIndex)
                          ? `border border-gray-100 border-t-0`
                          : ``
                      )}
                    >
                      {more}
                    </div>
                  )}
                </>
              )
            })}
        </div>
        <div
          className={classNames(
            // maxHeight ? `overflow-y-scroll` : ``,
            `bg-white border-t border-t-gray-200 lg:flex`,
            !mobileColumnLabels ? `hidden` : ``
          )}
        >
          {headings.map((heading, index) => (
            <div
              key={index}
              className={classNames(`px-4 py-2 lg:${heading.width}`)}
            >
              {heading.label}
            </div>
          ))}
        </div>
        {footer && (
          <div
            className={classNames(
              // maxHeight ? `overflow-y-scroll` : ``,
              `bg-white flex border-t border-t-lightgray px-4 py-2`
            )}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}

export default FlexTable
